import { render, staticRenderFns } from "./PositionMapping.vue?vue&type=template&id=1039bdbc&scoped=true&"
import script from "./PositionMapping.vue?vue&type=script&lang=js&"
export * from "./PositionMapping.vue?vue&type=script&lang=js&"
import style0 from "./PositionMapping.vue?vue&type=style&index=0&id=1039bdbc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1039bdbc",
  null
  
)

export default component.exports